export function saveBlobAsFile(blob, fileName) {
  // Создаем объект URL для blob данных
  const url = window.URL.createObjectURL(blob);
  
  // Создаем элемент <a> для загрузки файла
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  
  // Добавляем обработчик события клика и имитируем клик
  link.addEventListener('click', () => {
    setTimeout(() => {
      // Удаляем созданный URL после использования
      window.URL.revokeObjectURL(url);
    }, 150);
  });
  
  // Имитируем клик по ссылке
  link.click();
}